import Swiper from 'swiper';

import Section from '../Section';
import Media from '../global/Media';
import QuantityControls from '../global/QuantityControls';
import feather from 'feather-icons';
import Helpers from '../modules/Helpers';

export default class Product extends Section {
  constructor(theme, element, pageLoad, isFeaturedProduct = false) {
    super(theme, element, pageLoad);

    this.isFeaturedProduct = isFeaturedProduct;

    // Settings
    this.config = {
      shopifyAjaxAddUrl: '/cart/add.js',
      shopifyAjaxUrl: '/cart.js'
    };

    this.element = element;

    this.sectionId = this.element.dataset.sectionId;
    var productScript = this.element.querySelector('.product-json');

    // Product is not loaded, there is either no product section or the product is not selected
    if (!productScript) return;

    let self = this;

    this.addToCartForm = this.element.querySelector('#add-to-cart-form');
    this.product = JSON.parse(productScript.textContent);
    this.selects = this.element.querySelectorAll(
      '.selector-wrapper select, .product-option-select select'
    );
    this.selects.forEach((select) => {
      select.addEventListener('change', self.onSelectChange);

      // Ensure the change event is fired on the form when variants changed (for Shop Pay Installments)
      select.addEventListener('change', function () {
        const event = new Event('change');
        self.addToCartForm.dispatchEvent(event);
      });
    });

    this.originalSelect = this.element.querySelector('.original-select');
    this.price = this.element.querySelector('#price-field');
    this.priceContainer = this.element.querySelector('.product-page--pricing');
    this.cart = this.element.querySelector('#purchase');
    this.spb = this.element.querySelectorAll('.shopify-payment-button');
    this.sale = this.element.querySelectorAll('.sale-badge, .compare-at-price');
    this.sale_price = this.element.querySelector('.compare-at-price');
    this.productBox = document.getElementById('product-box');
    this.isAvailable = this.productBox ? this.productBox.getAttribute('data-instock') : false;
    this.pricePerUnit = this.element.querySelector(
      '.product-page--pricing--price-per-unit'
    );
    this.variantPercentageWrapper = this.element.querySelector(
      '.product-page--pricing--discount'
    );
    this.variantValueWrapper = this.element.querySelector(
      '.variant-value-wrapper'
    );
    this.thumbnails = this.element.querySelectorAll(
      '.product-single__thumbnail'
    );
    this.sku = this.element.querySelector('.indiv-product-sku-text');

    this.storeAvailabilityContainer = this.element.querySelector(
      '[data-store-availability-container]'
    );
    this.zoomSelector = '.zoomImg';
    this.addedTextTimeout = null;
    this.activeTab = null;
    this.activeTabContent = null;

    this.thumbnailChangesVariant = false;
    this.thumbnailChangesVariantElem = this.element.querySelector(
      '#thumbnail_changes_variant'
    );
    if (this.thumbnailChangesVariantElem) {
      this.thumbnailChangesVariant =
        this.thumbnailChangesVariantElem.value === 'true';
    }

    this.fullSizeMediaWrapper = this.element.querySelector('.product-media--full-size');

    this.stockEmailEnabled = false;
    this.stockEmailEnabledElem = this.element.querySelector(
      '.product-page--submit-action'
    );
    if (this.stockEmailEnabledElem) {
      this.stockEmailEnabled = this.stockEmailEnabledElem.dataset.stockEmailEnabled;
    }

    // Load media
    this.mediaById = new Map();
    var autoload = true;
    this.mediaTarget = this.element.querySelector('.product-single__medias');
    Array.prototype.forEach.call(
      this.element.querySelectorAll(
        '.product-single__thumbnail:not(.swiper-slide-duplicate)'
      ),
      (media_root) => {
        var media = new Media(
          this.theme,
          media_root,
          this.isFeaturedProduct ? media_root : this.mediaTarget,
          autoload
        );
        this.mediaById.set(media_root.dataset.mediaId, media);

        // Enable/disable drag to next slide when media is paused/playing
        media_root.addEventListener('media-play', () => {
          this.slider.allowTouchMove = false;
        });
        media_root.addEventListener('media-pause', () => {
          this.slider.allowTouchMove = true;
        });
      }
    );

    this.has3dModel = this.element.querySelectorAll(
      '.product-single__view-in-space'
    );

    if (this.has3dModel.length > 0) {
      // The "View in your space" button is there => we have a model. Load XR library so
      // it can show/hide the button based on browser/device support
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0'
        }
      ]);
    }

    // Load secondary media
    this.loadSecondaryMedia();
    window.addEventListener('resize', self.loadSecondaryMedia);

    // Add to cart click.
    if (this.cart) {
      this.cart.addEventListener('click', (e) => {
        e.preventDefault();
        self.disableCartButton();
        self.addToCart();
        let featuredProductSubmit = this.cart.dataset.submitType;
  
        if (featuredProductSubmit) {
          setTimeout(() => {
            location.reload();
          }, 1000);
        }
      });
    }

    // Handle thumbnail and media click
    this.thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('keydown', (e) => {
        self.handleThumbnailMediaClick(e);
      });

      thumbnail.addEventListener('click', (e) => {
        self.handleThumbnailMediaClick(e);
      });
    });

    this.quantityControls = new QuantityControls(this.theme, this.element);

    // Handle out of stock email form on page load
    if (!this.isAvailable) {
      let oosForm = document.querySelector('.variant-out-of-stock');

      if (oosForm) {
        oosForm.style.display = 'block';
      }
    }

    // Run store availablity on page load
    const productBox = document.getElementById('product-box');
    const selectedVar = productBox.getAttribute('data-selected-variant');
    let defaultVariantId;

    if (!selectedVar) {
      return;
    } else {
      defaultVariantId = selectedVar;
    }

    self.storeAvailability(defaultVariantId, self.product.title);

    this.responsiveTables();

    this.applyMasonryLayout();
    window.addEventListener('resize', this.applyMasonryLayout);
  }

  applyMasonryLayout = () => {
    if (!document.body.querySelector('.template-product')) return;

    const detailsCol = document.querySelector('[data-details-col]');
    let colOffset = '0';

    if (!this.isMobile()) {
      const galleryHeight = document.querySelector('[data-media-col]').offsetHeight;
      const formHeight = document.querySelector('[data-form-col]').offsetHeight;

      // Calc the height difference between the two top columns
      if (galleryHeight < formHeight) colOffset = '-' + (formHeight - galleryHeight) + 'px';
    }

    detailsCol.style.marginTop = colOffset;
  }

  isMobile = () => {
    return window.matchMedia('only screen and (max-width: 768px)').matches;
  }

  loadSecondaryMedia = () => {
    const showFullSizeMedia = this.fullSizeMediaWrapper && !this.isMobile();

    if (showFullSizeMedia) {
      this.thumbnails.forEach(thumbnail => {
        this.onMediaElementSelect(thumbnail, {
          load: true,
          togglePlay: false,
          focus: false
        });
      });
    } else {
      this.slider = this.initializeSlider();
    }
  }

  handleThumbnailMediaClick = (e) => {
    if (e.type === 'keydown') {
      if (e.code !== 'Enter' && e.code !== 'Escape') return;

      if (
        e.target.classList.contains('shopify-model-viewer-ui__button') ||
        e.target.classList.contains('plyr__control')
      ) {
        return;
      }
    }

    e.preventDefault();

    // Don't do anything on "view in your space" click, it's handled by Shopify XR library
    if (e.target.classList.contains('product-single__view-in-space')) return;

    // Don't do anything on 3d model overlay click, it will trigger an event itself
    if (
      e.target.tagName === 'MODEL-VIEWER' ||
      e.target.classList.contains('shopify-model-viewer-ui__controls-overlay')
    )
      return;

    // Don't do anything on plyr button click
    if (e.target.classList.contains('plyr__control')) return;

    // Image is clicked when there are no thumbnails, do nothing
    if (
      e.currentTarget.dataset.mediaType === 'image' &&
      this.slider.slidesPerViewDynamic() === 1
    )
      return;

    const isLoaded = e.currentTarget.classList.contains(
      'product-single__media--loaded'
    );
    const isActive = e.currentTarget.classList.contains(
      'product-single__media--active'
    );

    this.onThumbnailClick(e.currentTarget);

    // Loaded and active media will handle click internally in the component itself
    if (isLoaded && isActive) return;

    this.onMediaElementSelect(e.currentTarget, {
      load: true,
      togglePlay: true,
      focus: true
    });

    this.applyMasonryLayout();
  };

  /* Initialize the product thumbnail slider */
  initializeSlider = () => {
    let product = this;

    let thumbnails = /** @type {HTMLElement} */ (this.element.querySelector(
      '.product-single__thumbnails'
    ));
    if (!thumbnails) return;

    const numItems = this.element.querySelectorAll('.product-single__thumbnail')
      .length;

    const el = /** @type {HTMLElement} */ (thumbnails.querySelector(
      '.swiper-container'
    ));
    if (!el) return;

    // Do not show arrows or pagination if there is a single media item.
    const pagination = {
      el: el.parentNode.querySelector('.swiper-pagination'),
      type: 'bullets',
      clickable: true,
      renderBullet: (index, className) => {
        return (
          '<span class="' +
          className +
          '"><span class="swiper-pagination-bullet-dot"></span></span>'
        );
      }
    };

    var productThumbSlider = new Swiper(el, {
      updateOnImagesReady: true,
      spaceBetween: 20,
      threshold: 10,
      navigation: {
        nextEl: '.thumbs-direction-nav--next',
        prevEl: '.thumbs-direction-nav--prev'
      },
      pagination: pagination,
      loop: !thumbnails.classList.contains('no-arrows'),
      autoHeight: true,
      loopedSlides: 1,
      slidesPerView: el.dataset.slidesPerView,
      direction: el.dataset.direction || 'horizontal'
    });

    productThumbSlider.on('slideChange', function () {
      // Go to first/last slide when prev/next is clicked on first/last slide
      var slidesPerView = this.slidesPerViewDynamic();

      if (slidesPerView === 1) {
        // One element is displayed => make it active
        product.onMediaElementSelect(this.slides[this.activeIndex], {});
        // Select variant based on selected image
        if (product.thumbnailChangesVariant) {
          const variantId = this.slides[this.activeIndex].querySelector(
            '.product-single__thumbnail'
          ).dataset.variant;

          if (variantId) {
            product.onVariantSelected(variantId);
          }
        }
      } else {
        // Multiple elements in view, moving to next should animate to first
        if (this.isEnd) {
          this.slideTo(1);
        } else if (this.isBeginning) {
          this.slideTo(this.slides.length - 1 - slidesPerView);
        }
      }

      fixThumbSliderTabindex(this);
    });

    fixThumbSliderTabindex(productThumbSlider);

    if (numItems <= 1) {
      thumbnails
        .querySelector('.swiper-pagination-bullets')
        .classList.add('hide');
    }

    const parent = /** @type {HTMLElement} */ (el.parentNode);
    if (productThumbSlider.slidesPerViewDynamic() > 1) {
      parent.classList.add('product-single__thumbnails--carousel');
    }

    let lastBreakpoint = productThumbSlider.currentBreakpoint;

    productThumbSlider.on('resize', function (e) {
      if (this.slidesPerViewDynamic() > 1) {
        parent.classList.add('product-single__thumbnails--carousel');
      } else {
        parent.classList.remove('product-single__thumbnails--carousel');
      }

      if (this.currentBreakpoint != lastBreakpoint) {
        lastBreakpoint = this.currentBreakpoint;

        if (this.currentBreakpoint === 'max') {
          thumbnails.classList.toggle('hide', numItems < 1);
        } else {
          thumbnails.classList.toggle('hide', numItems <= 1);
        }
      }
    });

    if (productThumbSlider.currentBreakpoint === 'max') {
      thumbnails.classList.toggle('hide', numItems < 1);
    } else if (productThumbSlider.currentBreakpoint !== undefined) {
      thumbnails.classList.toggle('hide', numItems <= 1);
    }

    const paginationEl = el.parentNode.querySelector('.swiper-pagination');

    paginationEl.addEventListener(
      'keydown',
      (e) => {
        // Pressing enter on active bullet will activate the media and focus it.
        if (/** @type {KeyboardEvent} */ (e).code === 'Enter') {
          const elem = /** @type {HTMLSpanElement} */ (e.target);
          const index = Array.from(elem.parentElement.children).indexOf(elem);

          if (index === productThumbSlider.activeIndex) {
            this.onMediaElementSelect(
              productThumbSlider.slides[productThumbSlider.activeIndex],
              { forcePlay: true, focus: true }
            );
          }
        }
      },
      { capture: true }
    );

    if (productThumbSlider.device.ios) {
      paginationEl.classList.add('swiper-pagination-hide-focus');
    }

    return productThumbSlider;
  };

  mediaToDesktop = () => {
    // We've switched to desktop, move medias from thumbnains into separate box
    var parent = this.element.querySelector('.product-single__medias');

    this.mediaById.forEach((media) => {
      media.reattach(parent);
      if (media.loaded) {
        parent.classList.add('product-single__thumbnail--loaded');
      } else if (media.selected) {
        parent.classList.add('product-single__media--selected');
        media.load();
      }
    });
  };

  setVariantOptions = (values) => {
    let matchingVariants = this.product.variants.filter((variant) => {
      for (var i = 0; i < values.length; i++) {
        if (values[i] !== variant.options[i]) {
          return false;
        }
      }
      return true;
    });

    if (matchingVariants.length === 0) {
      this.updateVariant(null);
    } else {
      this.updateVariant(matchingVariants[0]);
    }
  };

  onSelectChange = () => {
    const selectsArray = Array.from(this.selects);

    const values = selectsArray.map((select, index) => {
      return select.value;
    });

    this.setVariantOptions(values);
  };

  onThumbnailClick = (thumbnail) => {
    if (this.thumbnailChangesVariant) {
      const variant_id = thumbnail.dataset.variant;

      if (variant_id) {
        this.onVariantSelected(variant_id);
      }
    }
  };

  onMediaElementSelect = (element, options) => {
    const media = this.mediaById.get(element.dataset.mediaId);

    // Pause all others.
    this.mediaById.forEach((otherMedia) => {
      if (otherMedia.media_id !== media.media_id) {
        otherMedia.pause();
        otherMedia.deselect();
      }
    });

    media.select();

    if (options.togglePlay) {
      media.togglePlay();
    } else if (options.forcePlay) {
      media.play();
    } else if (options.load) {
      media.load().then(function () {
        if (options.focus) {
          media.focus();
        }
      });
    }

    if (options.focus) {
      media.focus();
    }
  };

  onVariantSelected = (variant_id) => {
    const matchingVariants = this.product.variants.filter((variant) => {
      return variant.id == variant_id;
    });

    if (matchingVariants.length === 0) {
      this.updateVariant(null);
    } else {
      const variant = matchingVariants[0];
      this.updateVariant(matchingVariants[0]);

      for (var i = 0; i < variant.options.length; i++) {
        const select = /** @type {HTMLSelectElement} */ (this.element.querySelector(
          '#SingleOptionSelector-' + i
        ));
        if (!select) continue;
        select.value = variant.options[i];
        const e = new CustomEvent('change');
        select.dispatchEvent(e);
      }
    }
  };

  storeAvailability = (variantId, productTitle) => {
    const variantSectionUrl =
      '/variants/' + variantId + '/?section_id=store-availability';

    const storePickupEnabled = document.querySelector('.store-pickup-enabled');
    if (!storePickupEnabled) return;

    let availabilityContainer = document.createElement('div');
    availabilityContainer.classList.add(
      'product__store__availability__container'
    );

    let availabilityModal = document.createElement('div');
    availabilityModal.setAttribute(
      'data-store-availability-modal-container',
      ''
    );

    const targetFP = document.querySelector('.featured-product--submit-action');
    const targetEl = document.querySelector('.product-page--local-pickup');

    if (!availabilityContainer) return;

    availabilityContainer.innerHTML = '';

    fetch(variantSectionUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (storeAvailabilityHTML) {
        if (
          storeAvailabilityHTML.trim() === '' ||
          !storeAvailabilityHTML.includes('"store-availability-information"')
        ) {
          return;
        }

        // Remove existing content.
        const prevContent = document.querySelector(
          '.product__store__availability__container'
        );
        if (prevContent) {
          prevContent.remove();
        }

        availabilityContainer.innerHTML = storeAvailabilityHTML;
        const stripInnerSection = availabilityContainer.querySelector(
          '.store-availability-container'
        );
        availabilityContainer.innerHTML = stripInnerSection.innerHTML;

        if (targetFP) {
          targetFP.after(availabilityContainer);
          availabilityContainer.after(availabilityModal);
        } else if (targetEl) {
          targetEl.after(availabilityContainer);
          availabilityContainer.after(availabilityModal);
        }

        let storeAvailabilityModalOpen = document.querySelector(
          'a[data-store-availability-modal-open]'
        );
        let storeAvailabilityModalProductTitle = document.querySelector(
          'h2[data-store-availability-modal-product-title]'
        );

        // Only create modal if open modal element exists
        if (!storeAvailabilityModalOpen) {
          return;
        } else {
          // Open modal
          storeAvailabilityModalOpen.addEventListener('click', function () {
            // Trap focus within modal
            setTimeout(function () {
              var focusableEls = availabilityModal.querySelectorAll(
                'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
              );
              var firstFocusableEl = focusableEls[0];
              var lastFocusableEl = focusableEls[focusableEls.length - 1];
              var KEYCODE_TAB = 'Tab';

              /** @type {HTMLElement} */ (availabilityModal).focus();

              availabilityModal.addEventListener('keydown', function (e) {
                const isTabPressed =
                  e.key === 'Tab' || e.code === KEYCODE_TAB;

                if (!isTabPressed) return;

                // Shift + tab.
                if (e.shiftKey) {
                  if (document.activeElement === firstFocusableEl) {
                    /** @type {HTMLElement} */ (lastFocusableEl).focus();
                    e.preventDefault();
                  }
                } else {
                  // Tab.
                  if (document.activeElement === lastFocusableEl) {
                    /** @type {HTMLElement} */ (firstFocusableEl).focus();
                    e.preventDefault();
                  }
                }
              });
            }, 500);

            let modalContainer = /** @type {HTMLElement} */ (document.querySelector(
              'div[data-store-availability-modal-container]'
            ));
            let availabilityModal = /** @type {HTMLElement} */ (document.querySelector(
              '#StoreAvailabilityModal'
            ));
            let htmlBody = document.querySelector('body');

            htmlBody.classList.add('availability-modal--open');
            modalContainer.classList.add('store-availabilities-modal--open');
            availabilityModal.classList.add('open');
            availabilityModal.style.visibility = 'visible';

            // Modal close button
            const availabilityModalCloseButton = document.querySelector(
              '.store-availabilities-modal__close'
            );
            if (availabilityModalCloseButton) {
              availabilityModalCloseButton.addEventListener(
                'click',
                function () {
                  modalContainer.classList.remove(
                    'store-availabilities-modal--open'
                  );
                  htmlBody.classList.remove('availability-modal--open');
                  availabilityModal.classList.remove('open');
                  availabilityModal.style.visibility = 'visible';
                }
              );
            }
          });
        }

        // Update product title
        if (!storeAvailabilityModalProductTitle) {
          return;
        } else {
          storeAvailabilityModalProductTitle.textContent = productTitle;
        }
      });
  };

  handleVariant = (variant) => {
    this.originalSelect.value = variant.id;
    this.storeAvailability(variant.id, this.product.title);

    const is_sale =
      variant.compare_at_price && variant.compare_at_price > variant.price;

    this.sale.forEach((saleElem) => {
      saleElem.classList.toggle('hide', !is_sale);

      // If the compare at price is hidden we don't want to change the color of the variant price
      if (!this.sale_price.classList.contains('visually--hidden')) {
        // When we click through variants, we only want the price color to change if the variant is on sale
        this.priceContainer.classList.toggle('sale--color', is_sale);
      }
    });

    if (this.sku) {
      if (variant.sku) {
        this.sku.textContent = variant.sku;
      }

      this.sku.classList.toggle('hide', !variant.sku);
    }

    if (variant.unit_price_measurement) {
      this.pricePerUnit.innerHTML =
        '<span class="price">(' +
        this.theme.formatMoney(variant.unit_price) +
        ' / ' +
        (variant.unit_price_measurement.reference_value != 1
          ? variant.unit_price_measurement.reference_value
          : '') +
        ' ' +
        variant.unit_price_measurement.reference_unit +
        ')';
    } else {
      this.pricePerUnit.textContent = '';
    }

    if (!variant.available) {
      setTimeout(() => {
        let getAvailabilityContainer = document.querySelector('.product__store__availability__container');
        if (getAvailabilityContainer) {
          getAvailabilityContainer.classList.add('hide');
        }
      }, 500);

      this.showVariantOutOfStockForm(this.product.title, variant.title);
      this.price.textContent = this.theme.translations.soldOut;

      this.sale_price.textContent = '';
      if (this.cart) {
        this.cart.disabled = true;
        this.cart.textContent = this.theme.translations.soldOut;
      }

      this.spb.forEach((spb) => {
        spb.style.opacity = 1;
        Helpers.fadeOut(spb);
        spb.style.display = 'none';
      });

      if (this.variantPercentageWrapper) {
        this.variantPercentageWrapper.classList.add('hide');
      } else if (this.variantValueWrapper) {
        this.variantValueWrapper.classList.add('hide');
      }

      const event = new CustomEvent('variantUnavailable', {
        detail: {
          type: 'variantUnavailable',
          time: new Date(),
          variant: variant
        }
      });

      document.dispatchEvent(event);
    } else {
      const emailEnabled = document.querySelector('.variant-out-of-stock');

      if (emailEnabled) {
        this.hideVariantOutOfStockForm();
      }

      this.price.innerHTML = this.theme.formatMoney(variant.price);
      this.sale_price.innerHTML = is_sale
        ? this.theme.formatMoney(variant.compare_at_price)
        : '';

      if (this.cart) {
        this.cart.disabled = false;
        this.cart.textContent = this.theme.translations.addToCart;
      }

      this.spb.forEach((spb) => {
        spb.style.display = 'block';
        Helpers.fadeIn(spb);
      });

      if (
        this.variantPercentageWrapper &&
        variant.compare_at_price > variant.price
      ) {
        this.variantPercentageWrapper.classList.remove('hide');

        const percentage =
          ((variant.compare_at_price - variant.price) * 100.0) /
          variant.compare_at_price;

        this.variantPercentageWrapper.querySelector(
          '.variant-percentage'
        ).textContent = percentage.toFixed(0) + '%';
      } else {
        if (this.variantPercentageWrapper) {
          this.variantPercentageWrapper.classList.add('hide');
        }
      }

      if (
        this.variantValueWrapper &&
        variant.compare_at_price > variant.price
      ) {
        this.variantValueWrapper.classList.remove('hide');
        const value = variant.compare_at_price - variant.price;
        this.variantValueWrapper.querySelector(
          '.variant-value'
        ).innerHTML = this.theme.formatMoney(value);
      } else {
        if (this.variantValueWrapper) {
          this.variantValueWrapper.classList.add('hide');
        }
      }

      const event = new CustomEvent('variantAvailable', {
        detail: {
          type: 'variantAvailable',
          time: new Date()
        }
      });

      document.dispatchEvent(event);
    }

    if (variant.featured_media) {
      const mediaIndex = this.product.media.findIndex(
        (m) => m.id === variant.featured_media.id
      );

      if (mediaIndex >= 0) {
        const newImageThumb = this.element.querySelector(
          '.product-single__thumbnail[data-media-id$="' +
          variant.featured_media.id +
          '"]'
        );

        this.onMediaElementSelect(newImageThumb, { load: true });

        if (this.slider && this.slider.slidesPerViewDynamic() === 1) {
          // Mobile view active
          this.slider.slideToLoop(mediaIndex);
        }
      }
    }

    const closestSection = this.element.closest('.shopify-section');
    let isIndivProduct = false;
    if (closestSection)
      isIndivProduct = closestSection.classList.contains(
        'homepage-section--indiv-product-wrapper'
      );
    const hasMoreVariants = this.product.variants.length > 1;

    if (window.history.replaceState && !isIndivProduct && hasMoreVariants) {
      // Change url to include variant if we're not on homepage
      var search = [];
      if (window.location.search.length > 1) {
        // select non-variant query params
        search = window.location.search
          .slice(1)
          .split('&')
          .filter(function (q) {
            return q.indexOf('variant=') !== 0;
          });
      }
      // add current variant
      search.push('variant=' + variant.id);

      // set the url to include the variant
      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?' +
        search.join('&');
      window.history.replaceState({ path: newurl }, '', newurl);
    }
  };

  handleNullVariant = () => {
    const makeASelection =
      Array.from(this.selects).filter(function (select) {
        return select.value === '';
      }).length > 0;

    if (makeASelection) {
      this.price.textContent = this.theme.translations.makeASelection;
    } else {
      setTimeout(() => {
        let getAvailabilityContainer = document.querySelector('.product__store__availability__container');
        if (getAvailabilityContainer) {
          getAvailabilityContainer.classList.add('hide');
        }
      }, 500);
      this.price.textContent = this.theme.translations.unavailable;
      this.hideVariantOutOfStockForm();
    }

    if (this.cart) {
      this.cart.disabled = true;
    }

    if (this.sale.length > 0) {
      this.sale.forEach((saleElem) => {
        saleElem.classList.add('hide');
      });
    }

    if (this.variantPercentageWrapper)
      this.variantPercentageWrapper.classList.add('hide');
    if (this.variantValueWrapper)
      this.variantValueWrapper.classList.add('hide');
    if (this.sku) this.sku.classList.add('hide');
  };

  updateVariant = (variant) => {
    if (variant) {
      this.handleVariant(variant);
    } else {
      this.handleNullVariant();
    }
  };

  // @ts-ignore
  CART_LOADING = `<div class="lds-dual-ring"></div><span class="sr-only">${this.theme.translations.products.loading}</span>`;

  addToCart = async () => {
    this.clearError();

    let self = this;
    const formData = new FormData(this.addToCartForm);

    try {
      const fetchResult = await fetch(this.config.shopifyAjaxAddUrl, {
        method: 'POST',
        headers: {
          'x-requested-with': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        body: formData
      });

      const responseJson = await fetchResult.json();

      if (!fetchResult.ok) {
        this.addToCartFailed(responseJson);
      } else {
        this.addedToCart();
      }
    } catch (error) {
      console.error(error);
    }
  };

  disableCartButton = () => {
    if (this.addedTextTimeout) {
      clearTimeout(this.addedTextTimeout);
      this.addedTextTimeout = null;
    }

    this.cart.classList.add('disabled');
    this.cart.disabled = true;
    this.cart.innerHTML = this.CART_LOADING;
  };

  enableCartButton = () => {
    if (this.addedTextTimeout) {
      clearTimeout(this.addedTextTimeout);
      this.addedTextTimeout = null;
    }

    this.cart.classList.remove('disabled');
    this.cart.disabled = false;
    this.cart.innerHTML = this.theme.translations.addToCart;
  };

  addedToCart = (itemData) => {
    this.updateCart();
  };

  openCartPage = () => {
    window.location.href = this.addToCartForm
      .querySelector('#cart-link')
      .value.toString();
  };

  showCart = () => {
    const cartDrawerTop = document.querySelector('.cart-drawer__top');
    let cartDrawerStatus = document.querySelector('.js-cart-drawer-status');

    // TODO: Translate the string.
    cartDrawerStatus.textContent = `Item added to your cart`;

    cartDrawerTop.appendChild(cartDrawerStatus);

    var event = new CustomEvent('cart:open');
    document.querySelector('#cartSlideoutWrapper').dispatchEvent(event);
  };

  updateCart = async () => {
    try {
      const getResult = await fetch(this.config.shopifyAjaxUrl, {
        method: 'GET',
        headers: {
          'x-requested-with': 'XMLHttpRequest'
        },
        credentials: 'same-origin'
      });

      const responseJson = await getResult.json();

      if (!getResult.ok) {
        this.updateCartFailed(getResult);
      } else {
        this.updatedCart(responseJson);
      }
    } catch (error) {
      console.error(error);
    }
  };

  updatedCart = (data) => {
    this.theme.updateCartDrawer(data);
    this.enableCartButton();
    const cart_action = document.getElementById('PageContainer').dataset.cartAction;
    const cart_type = document.getElementById('PageContainer').dataset.cartType;

    if (cart_action === 'cart' && cart_type == 'page') {
      this.openCartPage();
    }
    else if (cart_action === 'added') {
      this.cart.innerHTML = this.theme.translations.added;

      if (this.addedTextTimeout) {
        clearTimeout(this.addedTextTimeout);
        this.addedTextTimeout = null;
      }

      this.addedTextTimeout = setTimeout(() => {
        this.cart.innerHTML = this.theme.translations.addToCart;
      }, 2000);
    }
    else if (cart_type === 'drawer' || cart_type === 'persistent') {
      // cart_action === drawer
      this.showCart();
    }
  };

  updateCartFailed = (response) => {
    this.enableCartButton();
    console.error('Updating the cart failed: ', response);
  };

  addToCartFailed = (response) => {
    this.enableCartButton();

    let errorText = 'Unknown error';

    if (response.status == 0) {
      errorText = 'Unable to connect to server';
    } else if (response.status == 422) {
      errorText = response.description;
    } else if (response.responseJSON) {
      // Process JSON error
      if (response.responseJSON.description) {
        errorText = response.responseJSON.description;
      } else {
        errorText = response.responseJSON.message;
      }
    } else if (response.responseText) {
      // Use plain text error
      errorText = response.responseText;
    }

    this.showError(errorText);
  };

  showError = (text) => {
    let cartError = document.createElement('div');
    cartError.id = 'cart-error';
    cartError.classList.add('alert', 'alert-danger');
    cartError.textContent = text;

    this.cart.parentNode.insertBefore(cartError, this.cart.nextSibling);
  };

  clearError = () => {
    const cartError = document.querySelector('#cart-error');

    if (cartError) {
      cartError.parentNode.removeChild(cartError);
    }
  };

  showVariantOutOfStockForm = (productTitle, variantTitle) => {
    if (this.stockEmailEnabled) {
      const outOfStockEmailBody = this.element.querySelector(
        '#notify-me-wrapper input[name="contact[body]"]'
      );
      const getform = document.querySelector('#sold-out');
      let varTitleContainer = /** @type {HTMLElement} */ (document.querySelector(
        '#variant_title'
      ));

      if (!varTitleContainer) {
        return;
      } else {
        varTitleContainer.innerText = '- ' + variantTitle;
      }

      getform.addEventListener('submit', function () {
        let btnElem = /** @type {HTMLInputElement} */ (document.querySelector(
          '#notify-me-wrapper .btn'
        ));
        btnElem.value = '';
      });

      // TODO: This needs translating.
      outOfStockEmailBody.value = `Please notify me when ${productTitle}, variant: ${variantTitle} becomes available.`;

      const outOfStockElem = this.element.querySelector(
        '.variant-out-of-stock'
      );

      Helpers.fadeIn(outOfStockElem);
    }
  };

  hideVariantOutOfStockForm = () => {
    if (this.stockEmailEnabled) {
      this.element.querySelector('.variant-out-of-stock').style.display =
        'none';
      this.element
        .querySelector('.product-page--submit-action')
        .classList.remove('hidden');
    }
  };

  responsiveTables = () => {
    this.element
      .querySelectorAll('.product-description-wrapper table')
      .forEach((table) => {
        let wrapper = document.createElement('div');
        wrapper.classList.add('rte__table-wrapper');
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      });
  };
}

function toHandle(o) {
  return o
    .toLowerCase()
    .replace(/[()]/g, '')
    .replace(/[\W]/g, '-');
}

function fixThumbSliderTabindex(slider) {
  // Only make thumbnails from current view tab-navigable
  var slidesPerView = slider.slidesPerViewDynamic();
  var activeStart = slider.activeIndex;
  var activeEnd = activeStart + slidesPerView;

  Array.from(slider.slides).forEach((slide, index) => {
    var tabindex = index >= activeStart && index < activeEnd ? '0' : '-1';
    var icon = slide.querySelector('.product-single__media__icon');
    if (icon) {
      icon.setAttribute('tabindex', tabindex);
    }

    const tabindexes = slide.querySelectorAll(
      '.product-single__media__icon, button, model-viewer, input:not([hidden]), .plyr, iframe, a, select, textarea'
    );

    tabindexes.forEach((tabitem) => {
      tabitem.tabIndex = tabindex;
    });
  });
}
